export default __webpack_public_path__ + "static/media/coloryourworld.f20c8bd1.png";